/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    active: PropTypes.bool,
    disabled: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    active: false,
    disabled: false,
};

const PaginationItem = (props) => {
    const classNames = [
        'c-pagination__item',
        props.active ? 'c-pagination__item_active' : '',
        props.disabled ? 'c-pagination__item_disabled' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

PaginationItem.propTypes = propTypes;

PaginationItem.defaultProps = defaultProps;

export default PaginationItem;
